/* eslint-disable require-unicode-regexp */
/* eslint-disable no-use-before-define */
/* eslint-disable max-statements-per-line */
/* eslint-disable react/prop-types */
import React from 'react'
import styled from 'styled-components'
import { ReactComponent as BlackArrow } from '../../../assets/icons/black-arrow.svg'
import DetalhesPedido from './DetalhesPedido'
import InformacoesCaixinha from './InformacoesCaixinha'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'

const PedidoContainer = styled.div`
  span {
    font-weight: 600;
  }
  .month-year {
    justify-content: center;
    flex-direction: column;
    flex: 10;
    @media (max-width: ${StyleGuide.mediaQuery.mobile}) {
      flex: 9;
    }
  }
  .envio-unificado {
    color: #3f49b5;
    font-weight: 700;
    font-size: 13px;
    @media (max-width: 905px) {
      font-size: 12px;
    }
  }
  .header {
    display: flex;
    padding: 16px 0px;
    justify-content: space-between;
  }
  .status {
    text-transform: capitalize;
    color: ${( { color } ) => color};
    font-size: 14px;
  }
  .price {
    padding-top: 5px;
    font-size: 12px;
  }
  .status-prices {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-right: 5px;
    flex: 3;
    color: ${( { color } ) => color};
    font-size: 12px;
  }
  .status-arrow {
    display: flex;
    align-items: center;
    flex: 1;
    justify-content: space-between;
    svg {
      cursor: pointer;
      transform: ${( { expanded } ) => expanded ? 'rotate(-180deg)' : 'rotate(0deg)'};
      transition: transform 0.2s;
    }
  }
  .status-envio {
    color: #53586f;
    font-size: 14px;
  }
  .div-status-envio {
    padding-top: 4px;
  }
  .estorno {
    color: ${( { colorUnderline } ) => colorUnderline};
    text-decoration: underline;
    cursor: pointer;
  }
`

const mapStatus = [
  { 'ARQUIVO_RECEBIDO': 'Arquivo recebido' },
  { 'CANCELADO': 'Cancelado' },
  { 'COTADO': 'Em processamento' },
  { 'COBRADO': 'Cobrado' },
  { 'DESPACHADO': 'Despachado' },
  { 'DEVOLVIDO': 'Devolvido' },
  { 'EM_DEVOLUCAO': 'Em devolução' },
  { 'EM_PROCESSAMENTO': 'Em processamento' },
  { 'EM_TRANSITO': 'Em trânsito' },
  { 'ENTREGUE': 'Entregue' },
  { 'ERRO_PROCESSAMENTO_PEDIDO_OPERADOR_LOGISTICO': 'Em processamento' },
  { 'ERRO_DURANTE_IMPORTACAO_PARA_OPERADOR_LOGISTICO': 'Em processamento' },
  { 'ESPERA': 'Em espera' },
  { 'EXTRAVIADO': 'Extraviado' },
  { 'FALHA_ENTREGA': 'Falha na entrega' },
  { 'FATURADO': 'Faturado' },
  { 'IMPORTADO_OPERADOR_LOGISTICO': 'Em processamento' },
  { 'MOTIVO_FALHA': 'Falha' },
  { 'NAO_ATUALIZADO': 'Não atualizado' },
  { 'REALOCADA': 'Realocada' },
  { 'SAIU_PRA_ENTREGA': 'Saiu para entrega' },
]

function Pedido( {
  pedido,
  getDadadosPedido,
  detalhePedido,
  loadingDetalhes,
  color,
  isExpanded,
  handleExpanded
} ) {
  function getColor() {
    const status = formatStatusPayment()
    if ( status === 'Pago' ) {
      return '#347A0B'
    }
    if ( status === 'ESPERA' ) {
      return '#B72133'
    }
    return '#53586F'
  }

  function formatPrice() {
    let parcelas = 1
    if ( pedido.plano === 'Anual' ) {
      parcelas = 12
    } else if ( pedido.plano === 'Semestral' ) {
      parcelas = 6
    } else if ( pedido.plano === 'Trimestral' ) {
      parcelas = 3
    }
    if (
      pedido.status === 'ESTORNADO' ||
      ( pedido.status === 'ESTORNO_PARCIAL' && pedido.statusEnvio !== 'ENTREGUE' )
    ) {
      return parseFloat( ( pedido.valorEstornado ) ).toFixed( 2 )
        .replace( '.', ',' )
    }
    return ( pedido.valor / parcelas ).toFixed( 2 ).replace( '.', ',' )
  }

  function renderMesTagPedido() {
    if ( pedido.tituloLivro ) {
      return (
        <div>
          <span>{pedido.tituloLivro}</span>
        </div>
      )
    } else {
      return (
        <div>
          <span>{month}</span>
          <span>{` - `}</span>
          <span>{pedido.anoTag}</span>
          {pedido.pedidoIsCombo ? <span className="envio-unificado">{` - Envio unificado`}</span> : null}
        </div>
      )
    }
  }

  function renderEstorno() {
    return (
      <div>
        <a
          href={ `https://imt0hjnp40.execute-api.us-east-1.amazonaws.com/prd/comprovante-estorno?vendaCobrancaId=${pedido.cobrancaId}` }
          rel="noopener noreferrer"
          target="_blank"
        >
          <span className="estorno">Comprovante de estorno</span>
        </a>
      </div>
    )
  }

  const statusPayment = pedido.status.toLowerCase().replace( /_/g, ' ' )

  function formatStatusEnvio() {
    const objectStatus = mapStatus.find( ( status ) => status[ pedido.statusEnvio ] )
    const formatedStatus = objectStatus ? Object.values( objectStatus ) : pedido.statusEnvio
    if (
      statusPayment === 'estornado' ||
      ( statusPayment === 'estorno parcial' && formatedStatus !== 'Entregue' )
    ) {
      return renderEstorno()
    }

    return formatedStatus
  }

  function formatStatusPayment() {
    if ( statusPayment === 'cobrado' ) {
      return 'Pago'
    }
    if (
      statusPayment === 'estorno parcial' &&
      pedido.statusEnvio === 'ENTREGUE'
    ) {
      return 'Pago'
    }
    return statusPayment
  }

  const month = `${pedido.mesTag.substring( 0, 3 )}.`

  function handleCLickArrow() {
    if ( !isExpanded() ) {
      getDadadosPedido( pedido.id )
    }
    handleExpanded( )
  }

  return (
    <PedidoContainer
      color={ getColor() }
      colorUnderline={ color }
      expanded={ isExpanded() }
    >
      <div
        className="header"
        onClick={ handleCLickArrow }
      >
        <div className="month-year">
          {renderMesTagPedido()}

          <div className="div-status-envio">
            <span className="status-envio">{formatStatusEnvio()}</span>
          </div>
        </div>

        <div className="status-prices">
          <span className="status">{formatStatusPayment()}</span>

          <span className="price">{`R$ ${formatPrice()}`}</span>
        </div>

        <div className="status-arrow">
          <BlackArrow />
        </div>
      </div>

      <div className="expanded">
        {isExpanded() && (
          <>
            <DetalhesPedido
              color={ color }
              detalhePedido={ detalhePedido }
              loadingDetalhes={ loadingDetalhes }
              pedido={ pedido }
              price={ formatPrice() }
              status={ formatStatusPayment() }
            />

            <InformacoesCaixinha
              color={ color }
              detalhePedido={ detalhePedido }
              loadingDetalhes={ loadingDetalhes }
            />
          </>
        )}
      </div>
    </PedidoContainer>
  )
}

Pedido.propTypes = {
}

export default Pedido
